import genericMessages from '@/messages/messages';

import { nonTrialFlowMessages, sleepQualityMessages, stressMessages } from './messages';
import { MobileHandoffFocus } from './types';

export const mobileHandoff: Record<string, MobileHandoffFocus> = {
	sleep: {
		CTA: genericMessages.exploreInApp,
		title: sleepQualityMessages.postOnboardRecommendationTitle,
		subtitle: sleepQualityMessages.postOnboardRecommendationSubTitle,
		image: '/_n/images/onboarding/sleep.png',
		description: sleepQualityMessages.postOnboardRecommendationDescription,
		url: 'https://calm.onelink.me/Pf5F/p0yhh04q',
		qrCode: '/_n/images/onboarding/handoff_sleep_qr.png',
	},
	stress: {
		CTA: genericMessages.exploreInApp,
		title: stressMessages.postOnboardRecommendationTitle,
		subtitle: stressMessages.postOnboardRecommendationSubTitle,
		image: '/_n/images/onboarding/stress.png',
		description: stressMessages.postOnboardRecommendationDescription,
		url: 'https://calm.onelink.me/Pf5F/7k1bbj1w',
		qrCode: '/_n/images/onboarding/handoff_stress_qr.png',
	},
	skipped: {
		CTA: genericMessages.downloadCalm,
		description: nonTrialFlowMessages.postOnboardRecommendationDescription,
		image: [
			'/_n/images/onboarding/non_trial_left.png',
			'/_n/images/onboarding/non_trial_center.png',
			'/_n/images/onboarding/non_trial_right.png',
		],
		url: 'https://calm.onelink.me/Pf5F/oislygnz',
		qrCode: '/_n/images/onboarding/handoff_skipped_qr.png',
	},
};
